import type {CSSObject} from "@emotion/react";
import styled from "@emotion/styled";
import {H2Text, textStyles} from "@/elements/text";

export const StyledWrapper = styled.div<{maxWidth?: string; wrapperStyles?: CSSObject}>(
  ({maxWidth, wrapperStyles}) => ({
    display: "flex",
    flexDirection: "column",
    width: "fit-content",
    maxWidth,
    marginBottom: 33,
    ...wrapperStyles,
  }),
);

export const StyledText = styled(H2Text, {
  shouldForwardProp: (prop) => prop !== "as",
})(({theme, styles, type}) => ({
  ...(theme?.breakpoints?.isMobile
    ? textStyles(theme).titleSmall
    : textStyles(theme).titleLarge),
  width: "100%",
  wordBreak: "break-word",
  ...(type ? textStyles(theme)[type] : {}),
  ...styles,
}));

export const StyledUnderline = styled.div<{
  fontSize?: number;
  underlinedLettersAmount?: number;
  height?: number;
}>(({theme, fontSize, underlinedLettersAmount, height}) => ({
  display: "block",
  width: theme?.breakpoints?.isMobile
    ? `calc(100% - ${(underlinedLettersAmount as number) * ((fontSize as number) * 1.5 * 0.72)}px)`
    : `calc(100% - ${(underlinedLettersAmount as number) * ((fontSize as number) * 2.5 * 0.72)}px)`, //0.72 - the average ratio of font size to width in pixels
  height: height || (theme?.breakpoints?.isMobile ? 2 : 4),
  marginTop: 5,
  backgroundColor: theme?.colors?.brandLightBlue,
  WebkitClipPath: "polygon(0% 100%, 1% 0%, 100% 0%, 99% 100%)",
  clipPath: "polygon(0% 100%, 1% 0%, 100% 0%, 99% 100%)",
}));
